/**
 * Constructores de topics del gateway WebSocket propio.
 *
 * Un ÚNICO socket multiplexado por topics/rooms. El server valida tenant +
 * permisos por topic en el handshake y en cada `subscribe`. El `tenantId` lo
 * antepone el propio builder para aislar datos entre tenants.
 */
export const RealtimeTopics = {
  /** Posiciones de toda la flota (1 Hz, alto volumen → coalescing en el store). */
  fleetPositions: (tenantId: string) => `tenant:${tenantId}:fleet:positions`,
  /** Alertas de conducción (FCW/LDW/fatiga/celular/exceso). */
  fleetAlerts: (tenantId: string) => `tenant:${tenantId}:fleet:alerts`,
  /** Estado de un viaje puntual (timeline, eventos). */
  trip: (tenantId: string, tripId: string) => `tenant:${tenantId}:trips:${tripId}`,
  /** Cambios de reservas/cupos en tiempo real. */
  bookings: (tenantId: string) => `tenant:${tenantId}:bookings`,
  /** Vencimientos documentales que cruzan umbral (72h hábiles). */
  documentAlerts: (tenantId: string) => `tenant:${tenantId}:documents:alerts`,
  /** Incidentes/contingencias (timelines ≤15/≤30 min). */
  incidents: (tenantId: string) => `tenant:${tenantId}:incidents`,
} as const;

export type RealtimeTopic = string;
